import { render, staticRenderFns } from "./ControllerNovelties.vue?vue&type=template&id=6503d55c"
import script from "./ControllerNovelties.vue?vue&type=script&lang=js"
export * from "./ControllerNovelties.vue?vue&type=script&lang=js"
import style0 from "./ControllerNovelties.vue?vue&type=style&index=0&id=6503d55c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports